import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import markdown from './introducing-hoang-dao.md';

export default function() {
  return (
    <AppShell
      seoTitle="Introducing Hoang Dao"
      description="Meet Hoang Dao, our Spencerian calligraphy expert at calligraphy.org."
    >
      <PublicShell>
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
